import React from 'react';
import { Typography } from 'antd';
import { LinkProps } from 'antd/lib/typography/Link';

export type { LinkProps };

const ProTypographyLink: React.FC<LinkProps> = (props) => {
  const { children, ...resProps } = props;

  return <Typography.Link {...resProps}>{children}</Typography.Link>;
};

export default ProTypographyLink;
